/* ============================================================
   MC PRODUCT CARD — swatch select + variant image swap
   Vanilla JS, guarded singleton. Mirrors reference initSwatches.

   Uses event delegation so it also works for cards injected by
   Horizon's results-list (collection/search filter, sort, infinite
   scroll) — no re-initialisation is needed after those AJAX morphs
   because swatch state is per-render, not persisted.

   Selecting a swatch swaps the card's main image to that colour's
   variant image. The URLs are rendered server-side onto the button
   (data-src / data-srcset in mc-product-card.liquid) at the same
   widths as the default image, so the browser reuses cached
   candidates and no layout shift occurs — width/height and the CSS
   box are unchanged, only the source.

   Horizon's own <product-card> has a previewVariant() action, but it
   drives a <slideshow-component> the mc- card does not use (it has two
   plain <img> layers instead), so the swap is done here.
   ============================================================ */
(function () {
  'use strict';
  if (window.__mcProductCardInit) return;
  window.__mcProductCardInit = true;

  /* Swap the card's default image to the selected variant image.
     The first swatch is pre-selected at render time and carries the image the
     card already shows, so re-selecting it is a no-op beyond the class change. */
  function showVariantImage(card, swatch) {
    var img = card.querySelector('.mc-card__img--default');
    if (!img) return;

    var src = swatch.getAttribute('data-src');
    var srcset = swatch.getAttribute('data-srcset');
    if (!src) return; // value has no variant media — leave the image alone

    // Remember the originally rendered image so a different card state can never
    // strand us on a variant image with nothing to fall back to.
    if (!img.dataset.mcOriginalSrc) {
      img.dataset.mcOriginalSrc = img.getAttribute('src') || '';
      img.dataset.mcOriginalSrcset = img.getAttribute('srcset') || '';
    }

    if (srcset) img.setAttribute('srcset', srcset);
    img.setAttribute('src', src);

    /* Suppress the hover cross-fade from here on: the second image belongs to
       whichever variant was featured at render time, so after an explicit
       colour choice it would reveal the wrong colour on hover. */
    card.classList.add('is-variant-selected');
  }

  /* Delegated clicks — work for current and future (AJAX-added) cards.
     preventDefault stops the wrapping product link from navigating. */
  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;

    var sw = target.closest('[data-mc-swatch]');
    if (!sw) return;

    e.preventDefault();
    var card = sw.closest('[data-mc-card]');
    if (card) {
      // aria-pressed must move with is-active, or the selected swatch is
      // announced as unselected (4.1.2).
      card.querySelectorAll('[data-mc-swatch]').forEach(function (x) {
        x.classList.remove('is-active');
        x.setAttribute('aria-pressed', 'false');
      });
    }
    sw.classList.add('is-active');
    sw.setAttribute('aria-pressed', 'true');

    if (card) showVariantImage(card, sw);
  });
})();
